import { useContext } from "react";
import { FeatureFlagContext } from "./featureFlagContext";

export const useFeatureToggle = (flag: string): boolean => {
  const flags = useContext(FeatureFlagContext);
  return !!flags[flag];
};
